function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "wv7txd0w4a",
  d: "M0.149 0.32L5.211 0.32 5.211 7.11 0.149 7.11z"
}), /*#__PURE__*/React.createElement("path", {
  id: "uh73rmsfxc",
  d: "M0.09 0.338L6.88 0.338 6.88 5.4 0.09 5.4z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#3B7CFF",
  d: "M7.29 5.063c1.313-.966 2.86-1.63 4.54-1.888V0C9.284.296 6.954 1.301 5.042 2.813l2.25 2.25z",
  transform: "translate(-541 -333) translate(541 333)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A3A3A",
  d: "M23.154 10.967c1.313-.965 2.86-1.63 4.54-1.887V5.904c-2.547.297-4.877 1.302-6.79 2.814l2.25 2.249z",
  transform: "translate(-541 -333) translate(541 333) rotate(90 24.3 8.436)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3B7CFF",
  d: "M3.175 11.83c.258-1.68.922-3.227 1.888-4.54l-2.25-2.25C1.301 6.954.296 9.284 0 11.83h3.175z",
  transform: "translate(-541 -333) translate(541 333)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A3A3A",
  d: "M19.039 5.926c.258-1.68.922-3.227 1.887-4.54l-2.249-2.25c-1.512 1.913-2.517 4.243-2.813 6.79h3.175z",
  transform: "translate(-541 -333) translate(541 333) rotate(90 18.395 2.531)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-541 -333) translate(541 333) translate(21.6 14.661)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "vqnnngtpvb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#wv7txd0w4a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3B7CFF",
  d: "M2.036.32C1.779 2 1.113 3.546.149 4.86l2.249 2.25C3.91 5.197 4.915 2.867 5.21.32H2.036z",
  mask: "url(#vqnnngtpvb)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3B7CFF",
  d: "M19.521 21.748c-1.313.966-2.86 1.63-4.54 1.888v3.175c2.547-.296 4.877-1.301 6.79-2.813l-2.25-2.25zM5.063 19.521c-.966-1.313-1.63-2.86-1.888-4.54H0c.296 2.547 1.301 4.877 2.813 6.79l2.25-2.25z",
  transform: "translate(-541 -333) translate(541 333)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-541 -333) translate(541 333) translate(4.95 21.411)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rqgsvtxrfd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#uh73rmsfxc"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3B7CFF",
  d: "M6.88 2.225C5.2 1.968 3.653 1.302 2.34.338L.09 2.587C2.003 4.099 4.333 5.104 6.88 5.4V2.225z",
  mask: "url(#rqgsvtxrfd)"
})))));

var SvgInProgressAutoAssignment = function SvgInProgressAutoAssignment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInProgressAutoAssignment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in-progress-auto-assignment.bbf27b97.svg";
export { ForwardRef as ReactComponent };